import React, { useState, useEffect, useContext } from "react";
import firebaseApp, { db } from "services/firebase";
import firebase from "firebase/compat/app";
import { AuthContext } from "context/Auth";
import usePosition from "hooks/usePosition";

export const LocationContext = React.createContext();

export const LocationProvider = ({ children }) => {
  const { user, userData, subscription, userLoading } = useContext(AuthContext);

  const [location, setLocation] = useState();
  const [locationLoaded, setLocationLoaded] = useState(false);

  const getLocation = (id) => {
    return db
      .collection("locations")
      .where("users", "array-contains", id)
      .onSnapshot((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          setLocation(doc.data());
        });

        setLocationLoaded(true);
      });
  };

  useEffect(() => {
    if (!user) return undefined;
    // getLocation returns the Firestore onSnapshot unsubscribe — capture it and
    // tear the listener down on unmount / user change. Without this, every
    // remount (including hot reloads) leaks another live listener.
    const unsubscribe = getLocation(user.uid);
    return () => {
      if (typeof unsubscribe === "function") unsubscribe();
    };
  }, [user]);

  return (
    <LocationContext.Provider
      value={{
        location,
        locationLoaded,
      }}
    >
      {children}
    </LocationContext.Provider>
  );
};
